/**
 * Um carrinho de corrida visto de lado, com a frente para a direita.
 * Desenhado numa caixa de 100 × 36 e redimensionado por `escala`.
 * O (x, y) é o canto de cima à esquerda da caixa.
 *
 * Lê: só as props.
 * Usado por: graficos/CorridaCarrinhos.tsx.
 */
import type { Cores } from './cores.ts';

export const LARGURA_CARRO = 100;
export const ALTURA_CARRO = 36;

interface Props {
  x: number;
  y: number;
  escala: number;
  cor: string;
  /** Número da posição (1, 2, 3...). null = carro parado na largada. */
  posicao: number | null;
  cores: Cores;
}

export function Carrinho({ x, y, escala, cor, posicao, cores }: Props) {
  return (
    <g transform={`translate(${x}, ${y}) scale(${escala})`}>
      {/* aerofólio */}
      <path d="M9 14 V7.5" stroke="#5b3a9b" strokeWidth={2.4} strokeLinecap="round" />
      <rect x={2} y={4} width={15} height={3.6} rx={1.8} fill="#5b3a9b" />
      {/* carroceria */}
      <path
        d="M3 27 V20 Q3 15.5 8 14.6 L23 12.6 Q31 3.5 46 3.5 H60 Q70 3.5 77 11.5 L92 14 Q99 15.5 99 21.5 V26 Q99 28.5 96.5 28.5 H5.5 Q3 28.5 3 27 Z"
        fill={cor}
        stroke="rgba(0,0,0,0.28)"
        strokeWidth={1}
      />
      {/* janela */}
      <path d="M31 12.5 Q37 6.5 46 6.5 H58 Q65 6.5 70 12.5 Z" fill="rgba(255,255,255,0.38)" />
      {/* rodas */}
      {[24, 80].map((centro) => (
        <g key={centro}>
          <circle cx={centro} cy={28.5} r={7.5} fill={cores.roda} />
          <circle cx={centro} cy={28.5} r={3} fill={cores.aro} />
        </g>
      ))}
      {/* número da posição */}
      <circle cx={34} cy={20.5} r={6.6} fill="#ffffff" stroke="rgba(0,0,0,0.25)" strokeWidth={0.8} />
      <text x={34} y={20.5} dy="0.36em" fontSize={posicao !== null && posicao >= 10 ? 7 : 8.5} fontWeight={800} textAnchor="middle" fill="#17141d">
        {posicao ?? '–'}
      </text>
    </g>
  );
}
